import { Card, Col, Input, Row, Form } from 'antd';
import gql from 'graphql-tag';
import get from 'lodash/get';
import { useState, useEffect } from 'react';
import { withApollo } from 'react-apollo';
import dayjs from 'dayjs';
import ProgressButton from 'react-progress-button';
import { GetCompanySettings } from 'src/_shared/api/graphql/custom/company/';
import { queryContactsByUserIdIndex } from 'src/_shared/api/graphql/custom/contacts/';
import { downloadFromS3Signed } from 'src/_shared/services/utils.js';
import ErinLogo from '../_shared/assets/erinwhite.png';
import { COLORS } from '../_shared/styles/colors';
import {
	CardStyles,
	Department,
	DetailContainer,
	FormItemStyles,
	FormTitle,
	InfoStyle,
	JobInfoContainer,
	NoteStyle,
	RemoveBottomMargin,
	candidateNameStyles,
	cardContainer,
	detailsTitle,
	headerBackground,
	logoContainer,
	menuColor,
	outerCardContainer,
	refererName,
	sectionTitle,
	subtitle,
	topSpacing,
} from './generalReferralStyles.js';

const GeneralReferralCard = ({
	referralData,
	companyId,
	onCreateContact,
	companyName,
	client,
}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState(false);
	const [buttonState, setButtonState] = useState('');
	const [isMore, setIsMore] = useState(false);
	const [text, setText] = useState([]);
	const [company, setCompany] = useState('');
	const [isAccepted, setIsAccepted] = useState('');
	const [contactData, setContactData] = useState([]);
	const [isDuplicate, setIsDuplicate] = useState(false);
	const [logoURL, setLogoURL] = useState('');

	const getCompanyData = async (policy = 'network-only') => {
		try {
			const { data } = await client.query({
				query: GetCompanySettings,
				variables: {
					id: companyId,
				},
				fetchPolicy: policy,
			});
			const companyData = data.getCompany;
			setCompany(companyData);
		} catch (error) {
			console.log(error);
		}
	};

	const getContactData = async () => {
		const { generalReferralAcceptanceId } = referralData;
		console.log('generalReferralAcceptanceId', generalReferralAcceptanceId);
		try {
			const { data } = await client.query({
				query: gql(queryContactsByUserIdIndex),
				variables: { userId: get(referralData, 'userId') },
				fetchPolicy: 'network-only',
			});
			const contactDataResult = get(
				data,
				'queryContactsByUserIdIndex.items',
				[]
			);
			setContactData(contactDataResult);
			const IsGeneralReferralAccepted = contactDataResult.find((item) => {
				return item.generalReferralAcceptanceId === generalReferralAcceptanceId;
			});
			if (IsGeneralReferralAccepted) {
				setIsAccepted(true);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		const initializeComponent = async () => {
			await getCompanyData();
			getContactData();
		};
		initializeComponent();
	}, []);

	useEffect(() => {
		const loadLogo = async () => {
			const companyLogo = get(company, 'logo');
			if (companyLogo) {
				const url = await downloadFromS3Signed(
					get(companyLogo, 'key'),
					get(companyLogo, 'bucket')
				);
				setLogoURL(url);
			}
		};
		if (company) {
			loadLogo();
		}
	}, [company]);

	const toggleLoading = () => {
		setLoading(!loading);
	};

	const handleCancel = () => {
		// setState({ visible: false }); // This seems unused in the original
	};

	const handleError = () => {
		setError(true);
		setButtonState('error');
	};

	const showAnimation = () => {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				try {
					resolve();
				} catch (error) {
					reject(error);
				}
			}, 5700);
		});
	};

	const toggleIsSubmitting = () => {
		setButtonState('loading');
		setIsSubmitting(!isSubmitting);
	};

	const whiteLabel = get(
		company,
		'whiteLabel',
		get(referralData, 'company.whiteLabel')
	);
	const brandColor = get(company, 'brandColor');
	const referrerMail = `mailto:${templateThis(referralData.referrerEmail)}`;

	function templateThis(value) {
		if (
			value !== undefined &&
			value.startsWith('null') === false &&
			value.startsWith('$null') === false
		) {
			return value;
		}

		return referralData.unavailable;
	}

	const handleSubmit = async (values) => {
		setButtonState('');

		const emailPattern =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
		let email = null;
		let importMethod = '';

		if (values.emailAddress && emailPattern.test(values.emailAddress)) {
			email = get(values, 'emailAddress', '').toLowerCase();
			importMethod = 'email';
		}

		const contactInput = {
			input: {
				firstName: get(values, 'firstName'),
				lastName: get(values, 'lastName'),
				socialMediaAccounts: null,
				userId: referralData.userId,
				companyId,
				jobHistory: null,
				importMethod,
				onDeckDate: dayjs(),
				onDeckStatus: 'onDeck',
				generalReferralAcceptanceId: referralData.generalReferralAcceptanceId,
			},
		};
		if (email) contactInput.input.emailAddress = email.toLowerCase();

		try {
			const { data } = await client.query({
				query: gql(queryContactsByUserIdIndex),
				variables: { userId: get(referralData, 'userId') },
				fetchPolicy: 'network-only',
			});
			const contactDataResult = get(
				data,
				'queryContactsByUserIdIndex.items',
				[]
			);
			let duplicate = false;
			let errorMessage = '';
			const isEmailAlreadyExists = contactDataResult.filter((item) => {
				const emailAddress =
					item.emailAddress !== undefined && item.emailAddress !== null
						? item.emailAddress.toLowerCase()
						: null;
				return emailAddress === email;
			});
			if (
				isEmailAlreadyExists !== undefined &&
				isEmailAlreadyExists.length > 0
			) {
				duplicate = true;
				errorMessage =
					'This person has already been added as a General Referral.';
			}

			if (duplicate) {
				form.setFields([
					{
						name: 'emailAddress',
						errors: [errorMessage],
					},
				]);
				handleError();
			} else {
				toggleIsSubmitting();
				showAnimation().then(() => {
					const url = get(referralData, 'jobData.jobUrl', null);
					onCreateContact(contactInput)
						.then((response) => {
							console.log('Response', response);
						})
						.then((res) => {
							setButtonState('success');
							setIsAccepted(true);
							setTimeout(() => {
								form.resetFields();
							}, 2200);
						});
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleSubmitWrapper = (e) => {
		e.preventDefault();
		form
			.validateFields()
			.then(handleSubmit)
			.catch((errorInfo) => {
				handleError();
			});
	};

	return (
		<section className="landing-background">
			<div
				className={headerBackground}
				style={{
					paddingTop: 10,
					backgroundColor: brandColor,
				}}
			>
				<Row type="flex" justify="center">
					<Col xs={23} m={24}>
						{logoURL && (
							<div className={logoContainer}>
								<img src={logoURL} alt="company logo" />
							</div>
						)}
					</Col>
				</Row>
			</div>
			<div className={outerCardContainer}>
				<div className={cardContainer}>
					<Card
						headStyle={{ height: 100 }}
						className={CardStyles}
						bordered={false}
						style={{ boxShadow: 'none' }}
					>
						<h2 className={FormTitle}>Congratulations on your referral for:</h2>

						<div className={JobInfoContainer}>
							<div style={{ display: 'inline-block' }}>
								<h3 className={candidateNameStyles}>
									<span className={Department}>
										{templateThis('General Referral')}
									</span>
								</h3>
								<div className={detailsTitle} />
							</div>
						</div>

						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Row type="flex" justify="center">
								<Col xs={24} m={24}>
									<p>
										Referred By:{' '}
										<a href={referrerMail} className={refererName}>
											{templateThis(referralData.referrer)}
										</a>
									</p>
								</Col>
							</Row>
							<Row type="flex" justify="center">
								If you accept the General Referral the Hiring Team at{' '}
								{companyName} will consider you for future roles if there is a
								good fit.
							</Row>
						</div>
						<div style={{ height: 'auto', marginTop: '0px' }}>
							<p className={NoteStyle}>
								To accept your General Referral, we need more information.
							</p>
						</div>
						{isAccepted && (
							<div className={topSpacing}>
								<Row>
									<h2 className={subtitle} style={{ color: COLORS.green }}>
										Thank you for accepting the General Referral
									</h2>
								</Row>
							</div>
						)}
						{!isAccepted && (
							<Form form={form} onFinish={handleSubmit}>
								<div className={DetailContainer}>
									<Row type="flex" justify="space-between" gutter={12}>
										<Col span={12}>
											<Form.Item
												className={FormItemStyles}
												name="firstName"
												rules={[
													{ transform: (value) => value?.trim() },
													{
														required: true,
														message: 'Please input First Name',
													},
												]}
											>
												<Input
													className={RemoveBottomMargin}
													placeholder="First Name"
												/>
											</Form.Item>
										</Col>
										<Col span={12}>
											<Form.Item
												className={FormItemStyles}
												name="lastName"
												rules={[
													{ transform: (value) => value?.trim() },
													{
														required: true,
														message: 'Please input Last Name',
													},
												]}
											>
												<Input
													className={RemoveBottomMargin}
													placeholder="Last Name"
												/>
											</Form.Item>
										</Col>
										<Col span={24}>
											<Form.Item
												className={FormItemStyles}
												name="emailAddress"
												rules={[
													{ type: 'email', message: 'Enter a valid email.' },
													{
														required: true,
														message: 'Please enter an email address.',
													},
												]}
											>
												<Input
													className={RemoveBottomMargin}
													placeholder="Email"
												/>
											</Form.Item>
										</Col>
									</Row>
								</div>
							</Form>
						)}
						<div style={{ height: 'auto', marginBottom: '30px' }}>
							<p className={InfoStyle}>
								By submitting, you consent to ERIN storing, processing and
								sharing your name and contact information with{' '}
								{templateThis(referralData.company)} hiring team. Your data will
								never be sold or redistributed by ERIN. Please read our{' '}
								<a
									className={menuColor}
									href="https://erinapp.com/privacy-policy"
									target="_blank"
									rel="noreferrer"
								>
									Privacy Policy
								</a>{' '}
								for more information.
							</p>
						</div>
						{isAccepted ? null : (
							<Form.Item className={DetailContainer}>
								<ProgressButton
									controlled
									state={buttonState}
									durationError={3000}
									durationSuccess={4500}
									onError={() => setButtonState('')}
									onClick={(e) => {
										if (buttonState === '') {
											handleSubmitWrapper(e);
										}
									}}
								>
									Accept Your Referral
								</ProgressButton>
							</Form.Item>
						)}
					</Card>
				</div>
			</div>
			{!whiteLabel && (
				<div style={{ marginTop: 10 }} className={headerBackground}>
					<p className={sectionTitle}>powered by</p>
					<a href="https://erinapp.com/">
						<img alt="logo" style={{ width: 200 }} src={ErinLogo} />
					</a>
				</div>
			)}
		</section>
	);
};

export default withApollo(GeneralReferralCard);
